import { memo } from 'react';
import { IOrder } from 'modules/sales/common/interfaces/IOrder';
import { FlexBox } from '@dfl/mui-react-common';
import OrderExportMenu from '../OrderExportMenu/OrderExportMenu';
import { OrderCompleteButton } from '../OrderCompleteButton';

type UserStatusProps = {
  record: IOrder;
};

const OrderRowActions = ({ record }: UserStatusProps) => {
  return (
    <FlexBox alignItems={'center'}>
      <OrderCompleteButton order={record} variant='icon' />
      <OrderExportMenu order={record} variant='icon' />
    </FlexBox>
  );
};

export default memo(OrderRowActions);
